import React, { Component } from 'react';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';

import { Auth } from '../../support';
import { useStore } from '../../store';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import UsuarioPasswordForm from '../../app/usuarios/upsert/components/UsuarioPasswordForm';

class UserPassword extends Component {
  componentDidMount() {
    const data = Auth.getUser();

    this.props.passwordActions.setPartialState({ data });
  }

  handleOnChange = (event) => {
    this.props.passwordActions.setPartialState({
      ...event,
      error: undefined,
      result: undefined,
    });
  };

  handleOnSubmit = async () => {
    const {
      data: { email, nombre, old_password, password, password_confirmed },
    } = this.props.password;

    const body = {
      email,
      nombre,
      old_password,
      password,
      password_confirmed,
    };

    await this.props.passwordActions.update(body);

    const { result } = this.props.password;

    if (!!result && !!this.props.onComplete) {
      this.props.onComplete(result.data);
    }
  };

  renderError = () => {
    const { error } = this.props.password;

    return (
      <div className="result-container">
        <ResponseError
          variant="inline"
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data, isValidForm, busy, result, error } = this.props.password;

    return (
      <>
        <Row>
          <Col>
            <p className="text-muted">
              Por seguridad, la contraseña debe contener una mayúscula, un número y un caracter especial ($%&#.?¡@/)
            </p>
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
          >
            <UsuarioPasswordForm
              data={data}
              onFormDataChange={this.handleOnChange}
            />
          </Col>
        </Row>

        {!!result && <p className="text-info">Actualizado por última vez a las {result.data.updated_at}</p>}

        {!!error && this.renderError()}

        <div>
          <LoadingButton
            disabled={busy || !isValidForm}
            loading={busy}
            onClick={this.handleOnSubmit}
          >
            Guardar
          </LoadingButton>
        </div>
      </>
    );
  }
}

const mapState = (store) => {
  return { password: store.app.usuarios.password };
};

const mapActions = (actions) => {
  return { passwordActions: actions.app.usuarios.password };
};

export default connect(useStore, mapState, mapActions)(UserPassword);
